<template>
  <div class="webPlayerContainer">
    <div @click.prevent="goBack" @touchstart="goBack" class="back"></div>
    <div v-show="vodObject.isPreview === false && vodObject.type !== 'live'" @click.prevent="rewind" class="beforeSec"></div>
    <div v-show="vodObject.isPreview === false && vodObject.type !== 'live'" @click.prevent="foward" class="afterSec"></div>
    <div v-show="isPlaying === false" @click.prevent="play" class="playBtn"></div>
    <div v-show="isPlaying" @click.prevent="pause" class="pauseBtn"></div>
    <div v-if="vodObject.isAd === false" class="more" @click.prevent="openSetting"></div>
    <div class="progressBox">
      <div class="sTime">{{ currTimeStr }}</div>
      <div class="eTime">{{ totalTimeStr }}</div>
      <div v-if="vodObject.type === 'live'" id="seek-bg" class="progressBg01">
        <div class="progressPlay " :style="{ width : seekWidth }"></div>  <!-- %로 컨트롤 -->
      </div>
      <div v-else id="seek-bg" class="progressBg01" @click.prevent="click" @touchstart="mousedown" @touchmove="touchmove" @touchend="mouseup">
        <div class="progressBall" :style="{ left : seekPoint }">
          <div class="circle"></div>
        </div>
        <div class="progressPlay " :style="{ width : seekWidth }"></div>  <!-- %로 컨트롤 -->
      </div>
    </div>
    <div @click.stop="hide" class="dim"></div>
  </div>
</template>
<script>
import utils from '@/common/util/utils'
export default {
  name: 'VodPlayerUI',
  props: {
    vodObject: {
      type: Object
    }
  },
  data () {
    return {
      duration: 0,
      currTimeStr: '00:00',
      totalTimeStr: '00:00',
      seekWidth: '0%',
      seekPoint: '0%',
      isPlaying: false
    }
  },
  mounted () {
    this.$emit('on-load', this)
  },
  methods: {
    click (e) {
      this.$parent.startUITimer()
      this.seek(e)
    },
    getPoint (e) {
      var event = e != null ? e : window.event
      return { 'x': event.pageX ? event.pageX : event.clientX, 'y': event.pageY ? event.pageY : event.clientY }
    },
    getVodPlayer () {
      return this.$parent.vodPlayer
    },
    goBack () {
      return this.$parent.goBack()
    },
    hide () {
      if (this.$parent.isShowVodControl) {
        this.$parent.isShowVodControl = false
        this.$parent.clearUITimer()
      }
    },
    foward () {
      this.$parent.startUITimer()
      this.getVodPlayer().seek(this.getVodPlayer().getCurrentTime() + 10)
    },
    rewind () {
      this.$parent.startUITimer()
      this.getVodPlayer().seek(this.getVodPlayer().getCurrentTime() - 10)
    },
    mousedown (e) {
      this.$parent.clearUITimer()
      this.pause()
    },
    mousemove (e) {
      this.seek(e)
    },
    mouseup (e) {
      this.$parent.startUITimer()
      this.play()
    },
    openSetting () {
      this.$parent.openSetting()
    },
    pause () {
      this.getVodPlayer().pause()
    },
    play () {
      this.getVodPlayer().play()
    },
    seek (e) {
      let range = utils.getAbsoluteBounce(document.getElementById('seek-bg'))
      let posX = this.getPoint(e).x
      posX = posX - range.x
      let pct = posX / range.width
      if (pct > 1) pct = 1
      this.getVodPlayer().seek(parseInt(this.duration * pct))
    },
    setTime (t) {
      if (this.duration > 0) {
        this.currTimeStr = utils.convertSecondToPlayTime(Math.round(t))
        let pct = t / this.duration * 100 + '%'
        this.seekWidth = pct
        this.seekPoint = pct
      }
    },
    touchmove (e) {
      let touchEvent = null
      for (let i in e.touches) {
        if (e.touches[i] instanceof Touch) touchEvent = e.touches[i]
      }
      if (touchEvent != null) this.seek(touchEvent)
    },
    updateLivePlay () {
      const startTimeInt = this.convertTimeToInt(this.currTimeStr)
      const totalTimeInt = this.convertTimeToInt(this.totalTimeStr)
      const date = new Date()
      const playedTimeStr = date.getHours() + ':' + new Date().getMinutes()
      const playedTimeInt = this.convertTimeToInt(playedTimeStr)
      let seekWidth = (playedTimeInt - startTimeInt) / (totalTimeInt - startTimeInt) * 100
      this.seekWidth = (seekWidth > 100 ? 100 : seekWidth) + '%'
    },
    convertTimeToInt (str) {
      let split = str.split(':')
      let time = 0
      for (let i = split.length - 1; i > -1; i--) {
        time += parseInt(split[i]) * Math.pow(60, split.length - i)
      }
      return time
    },
    reset () {
      switch (this.vodObject.type) {
        case 'live':
          if (this.vodObject.isAd) {
            this.duration = this.vodObject.getAdDuration()
            this.totalTimeStr = utils.convertSecondToPlayTime(Math.round(this.duration))
          } else {
            this.currTimeStr = this.vodObject.startTime
            this.totalTimeStr = this.vodObject.endTime
          }
          break
        default:
          this.duration = this.vodObject.totalPlayTime
          this.totalTimeStr = utils.convertSecondToPlayTime(Math.round(this.duration))
          break
      }
    }
  }
}
</script>

<style>
.webPlayerContainer { position: absolute; top:0px; left:0px;  width: 100%;   height: 100%;   z-index: 1;}
.webPlayerContainer .back { position: absolute;  top: 15px;  left: 15px; width: 24px;  height: 24px;  background: url(../../assets/images/ic_gnb_back_w.png) no-repeat; background-size:100% 100%; z-index: 1;}
.webPlayerContainer .beforeSec  { position: absolute;  top: 46%;  left: 25%; width: 36px;  height: 36px;  background: url(../../assets/images/ic_player_10_back.png) no-repeat; background-size:100% 100%; z-index: 1;}
.webPlayerContainer .afterSec { position: absolute;  top: 46%;  right: 25%; width: 36px;  height: 36px;  background: url(../../assets/images/ic_player_10_play.png) no-repeat; background-size:100% 100%; z-index: 1;}
.webPlayerContainer .playBtn  { position: absolute;  top: 43%;  left: 45%; width: 54px;  height: 54px; background: url(../../assets/images/ic_player_play.png) no-repeat; z-index: 1; background-size: 100% 100%;}
.webPlayerContainer .pauseBtn { position: absolute;  top: 43%;  left: 45%; width: 54px;  height: 54px; background: url(../../assets/images/pause.png) no-repeat; z-index: 1; background-size: 100% 100%;}
.webPlayerContainer .more { position: absolute;  top: 15px;  right: 15px; width: 24px;  height: 24px;  background: url(../../assets/images/ic_player_more.png) no-repeat; background-size:100% 100%; z-index: 1;}
.webPlayerContainer .progressBox  { position: absolute;  bottom: 0px; left: 0px; z-index: 1;width: 100%;   height: 55px; z-index: 1}
.webPlayerContainer .sTime  { position: absolute;  top: 15px;  left: 15px;  text-align:left; z-index: 1; color: #ffffff;font-size:12px;}
.webPlayerContainer .eTime  { position: absolute;  top: 15px;  right: 15px; text-align:left; z-index: 1; color: #ffffff;font-size:12px;}
.webPlayerContainer .progressBg01 {width: 73%;height: 5px;border-radius: 5px;background-color: rgba(238, 238, 238, 0.1);position: absolute;top: 23px;left: 72px;}
.webPlayerContainer .progressBg01 .progressBall {position:absolute;top: -8px;}
.webPlayerContainer .progressBg01 .progressBall .circle {width: 18px;height: 18px;background: #eeeeee;border-radius:50%;position:absolute;left:-11px;top: 1px;}
.webPlayerContainer .progressBg01 .progressPlay {height: 5px;border-radius: 5px;background:#1351f9;}
.webPlayerContainer .dim {height: 100%}
</style>
